'use client';

import type { Session } from 'src/app/api/auth/auth-client';

import { createContext, useContext, useState } from 'react';

type SessionContextType = {
  session: Session | null;
  clearSession: () => void;
  isClearing: boolean;
};

const SessionContext = createContext<SessionContextType>({
  session: null,
  clearSession: () => {},
  isClearing: false,
});

export function useSession(): Session | null {
  return useContext(SessionContext).session;
}

export function useClearSession(): () => void {
  return useContext(SessionContext).clearSession;
}

export function useIsSessionClearing(): boolean {
  return useContext(SessionContext).isClearing;
}

export default function SessionProvider({ value, children }: { value: Session | null; children: React.ReactNode }) {
  const [session, setSession] = useState<Session | null>(value);
  const [isClearing, setIsClearing] = useState(false);

  return (
    <SessionContext.Provider
      value={{
        session,
        clearSession: () => {
          setIsClearing(true);
          setSession(null);
        },
        isClearing,
      }}
    >
      {children}
    </SessionContext.Provider>
  );
}
